<div class="content">
  <div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ questionId ? 'Edit Question' : 'Add Questions' }}</h1>
    </div>
    <div class="card border-left-primary shadow mb-4">
      <div class="card-body">
        <p class="text-muted">Assign severity to each question. Category weightage is configured in the office questionnaire, not on individual questions.</p>
        <div *ngIf="severityLoading" class="alert alert-info" role="status">Loading severity tags...</div>
        <div *ngIf="severityError" class="alert alert-danger" role="alert">
          {{ severityError }} <button type="button" class="btn btn-sm btn-outline-danger ml-2" (click)="loadSeverityTags()">Retry</button>
        </div>
        <div *ngIf="!severityLoading && !severityError && severityOptions.length === 0" class="alert alert-warning">
          No active audit severities are configured for this client.
          <a
            *ngIf="authService.hasAnyRole(['audit-view', 'audit-edit'])"
            class="btn btn-sm btn-outline-primary ml-2"
            [routerLink]="['/audit/severity-configuration']">
            Open Severity Configuration
          </a>
          <span *ngIf="!authService.hasAnyRole(['audit-view', 'audit-edit'])">
            Ask an audit administrator to configure them under EVM Admin → Severity Configuration.
          </span>
        </div>
        <div *ngIf="loadingQuestion" class="alert alert-info" role="status">Loading question...</div>
        <div *ngIf="questionError" class="alert alert-danger" role="alert">
          {{ questionError }} <button type="button" class="btn btn-sm btn-outline-danger ml-2" (click)="loadQuestion()">Retry</button>
        </div>
        <form [formGroup]="addQuestionsForm" (ngSubmit)="submitForm()">
          <fieldset [disabled]="!canEdit || saving || loadingQuestion">
            <div class="row mb-3">
              <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Question Domain</mat-label>
                  <mat-select [value]="selectedDomain" [disabled]="!!questionId"
                              (selectionChange)="changeDomain($event.value)">
                    <mat-option value="DENTAL">Dental</mat-option>
                    <mat-option value="MEDICAL">Medical</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Category</mat-label>
                  <mat-select *ngIf="!isCustomCategory" formControlName="category">
                    <mat-option *ngFor="let cat of categoryArray" [value]="cat.category">{{ cat.category }}</mat-option>
                  </mat-select>
                  <input *ngIf="isCustomCategory" matInput formControlName="category" placeholder="Enter new category">
                  <mat-error *ngIf="addQuestionsForm.get('category').hasError('required')">Category is required.</mat-error>
                  <span *ngIf="!questionId && canEdit" matSuffix>
                    <button *ngIf="!isCustomCategory" type="button" mat-icon-button color="primary" (click)="enableCustomCategory()" aria-label="Add category"><mat-icon>add</mat-icon></button>
                    <button *ngIf="isCustomCategory" type="button" mat-icon-button color="warn" (click)="resetCategory()" aria-label="Choose existing category"><mat-icon>close</mat-icon></button>
                  </span>
                </mat-form-field>
              </div>
              <div class="col-12 col-lg-9">
                <div class="table-responsive">
                  <table class="table table-bordered" formArrayName="questions">
                    <thead><tr><th>Pseudo Name</th><th>Question</th><th>Procedure Code</th><th>Severity</th><th *ngIf="!questionId && canEdit">Action</th></tr></thead>
                    <tbody>
                      <tr *ngFor="let item of questions.controls; let i = index" [formGroupName]="i">
                        <td><mat-form-field appearance="outline"><input matInput formControlName="pseudoName" aria-label="Pseudo name"></mat-form-field></td>
                        <td><mat-form-field appearance="outline"><input matInput formControlName="question" aria-label="Question"><mat-error>Question is required.</mat-error></mat-form-field></td>
                        <td><mat-form-field appearance="outline"><input matInput formControlName="questionCode" aria-label="Procedure code"></mat-form-field></td>
                        <td>
                          <mat-form-field appearance="outline">
                            <mat-label>Severity</mat-label>
                            <mat-select formControlName="severity" [disabled]="!canEdit || saving || severityLoading">
                              <mat-option *ngIf="item.get('severity').value && !isActiveSeverity(item.get('severity').value)" [value]="item.get('severity').value" disabled>
                                {{ severityLabel(item.get('severity').value) }} (unavailable)
                              </mat-option>
                              <mat-option *ngFor="let tag of severityOptions" [value]="tag.name">{{ severityLabel(tag.name) }}</mat-option>
                            </mat-select>
                            <mat-error>Select an active severity.</mat-error>
                          </mat-form-field>
                        </td>
                        <td *ngIf="!questionId && canEdit" class="text-nowrap">
                          <button type="button" mat-icon-button color="warn" [disabled]="questions.length <= 1 || saving" (click)="removeQuestion(i)" aria-label="Remove question"><mat-icon>delete</mat-icon></button>
                          <button type="button" mat-icon-button color="primary" [disabled]="saving" (click)="addQuestionRow()" aria-label="Add question"><mat-icon>add</mat-icon></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </fieldset>
          <div class="d-flex justify-content-between mt-3">
            <button type="button" routerLink="/questions" [queryParams]="{ domain: selectedDomain }" class="btn btn-secondary" [disabled]="saving">Cancel</button>
            <button *ngIf="canEdit" mat-raised-button color="primary" type="submit"
                    [disabled]="saving || loadingQuestion || questionError || severityLoading || severityError || !questions.length || addQuestionsForm.invalid">
              {{ saving ? 'Saving...' : questionId ? 'Update' : 'Save' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
